import { Button, Link, FormControl, FormLabel, Input, Modal, ModalClose, ModalDialog, ModalOverflow, Stack, Typography, Select, Option, Autocomplete, Textarea, IconButton, Card, CardContent, Chip, DialogTitle, Divider, DialogContent, DialogActions } from "@mui/joy";
import { useContext, useEffect, useRef, useState } from "react";
import { LayoutContext } from "../../context";
import { motion, AnimatePresence } from "framer-motion";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { APICreateEvent, APIDeleteEvent, APIDeleteFile, APIGetEmployee, APIGetFiles, APIUpdateDeals, APIUpdateEvent } from "../../api";
import Cookies from "js-cookie";
import { getAuthToken } from "../../auth";
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';


export default function ModalConfirmDeleteFile() {
    const { modalConfirmDeleteFile, setModalConfirmDeleteFile, setModalEvent, setFiles, tokenEmployee, modalEvent } = useContext(LayoutContext);

    const [ loading, setLoading ] = useState(false);

    const latest = useRef(null);
    latest.current = { modal: modalConfirmDeleteFile, token: tokenEmployee,
        eventKey: `${modalEvent?.open || false}:${modalEvent?.event?.id || 'new'}` };

    function deleteFile() {
        const target = modalConfirmDeleteFile.file;
        const token = tokenEmployee;
        const eventKey = latest.current.eventKey;
        if (!target || !token || getAuthToken() !== token || loading) return;
        const sameSession = () => latest.current.token === token && getAuthToken() === token
            && latest.current.eventKey === eventKey;
        const sameConfirmation = () => sameSession() && latest.current.modal.open
            && latest.current.modal.file === target;
        setLoading(true);
        APIDeleteFile(target.id, target.name, modalConfirmDeleteFile.bitrix_deal_id).then(data => {
            if (data?.status === 'ok') {
                // Apply exactly the confirmed deletion. A delayed refresh from
                // another deal must never replace the current event's files.
                if (sameSession()) setFiles(previous => previous.filter(file => file.fromApplication
                    || (file !== target && (!target.id || String(file.id) !== String(target.id)))));
                if (sameConfirmation()) setModalConfirmDeleteFile(previous => previous.file === target
                    ? { file: null, bitrix_deal_id: null, open: false } : previous);
            } else if (sameConfirmation()) alert(data?.message || 'Не удалось удалить файл');
        }).catch(() => {if (sameConfirmation()) alert('Не удалось удалить файл. Повторите попытку.');})
          .finally(() => setLoading(false));
    }

    
    return (
        <AnimatePresence>
            {
                modalConfirmDeleteFile.open && (
                    <Modal
                        sx={{ zIndex: 10102 }}
                        open={modalConfirmDeleteFile.open}
                        onClose={() => setModalConfirmDeleteFile({ ...modalConfirmDeleteFile, open: false })}
                        slotProps={{
                            backdrop: {
                                component: motion.div,
                                initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                                animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                                exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                                transition: { duration: 0.3, ease: "easeInOut" },
                            }
                        }}
                    >
                        <ModalOverflow sx={{ height: 'auto' }}>
                            <ModalDialog
                                size="lg"
                                component={motion.div}
                                initial={{ opacity: 0, y: -10, scale: 0.98 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 10, scale: 0.98 }}
                                transition={{ duration: 0.2, ease: "easeInOut" }}
                                sx={(theme) => ({
                                    [theme.breakpoints.up("xl")]: {
                                        width: '550px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("xl")]: {
                                        width: '550px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("lg")]: {
                                        width: '550px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("md")]: {
                                        width: '450px',
                                        mx: 0,
                                    },
                                    [theme.breakpoints.down("sm")]: {
                                        width: '95%',
                                        p: 3,
                                    },
                                    width: '100%'
                                })}
                            >
                                <DialogTitle>
                                    <WarningAmberRoundedIcon />
                                    Удаление файла
                                </DialogTitle>
                                <Divider />
                                <DialogContent>
                                    <Typography>
                                        Вы уверены что хотите удалить файл <Typography component={"span"} level="title-md">{modalConfirmDeleteFile?.file?.name}</Typography>?
                                    </Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button loading={loading} variant="solid" color="danger" onClick={deleteFile}>
                                        Да, удалить
                                    </Button>
                                    <Button variant="plain" color="neutral" onClick={() => setModalConfirmDeleteFile({ file: null, bitrix_deal_id: null, open: false })}>
                                        Отмена
                                    </Button>
                                </DialogActions>
                            </ModalDialog>
                        </ModalOverflow>
                    </Modal>
                )
            }
        </AnimatePresence>
    );
}
